import Component from "../../lib/Component.js";

const GoogleTagManager = ({ gtmId, consentPromise }) => {
  let mounted = false;

  const loadGtmScript = async () => {
    const { analytics } = await consentPromise;
    if (!analytics) return;

    // Push GTM start event (dataLayer already initialized in _base.twig)
    (window.dataLayer = window.dataLayer || []).push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

    // Load gtm.js script
    var gtmScript = document.createElement("script");
    gtmScript.async = true;
    gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=" + gtmId;

    var firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(gtmScript, firstScript);
  };

  return new Component({
    onMount: () => {
      if (mounted) return;
      mounted = true;

      loadGtmScript();
    },
  });
};

export default GoogleTagManager;
